import React from "react";
import "../home-page/HomePage.css";
import ArchiveMain from "./ArchiveMain";
export default function ArchivePage() {
  return (
    <div className="typora-container">
      <ArchiveMain />
    </div>
  );
}
